<template>
  <div class="container mb-5">
    <div class="row mb-5 my-md-5">
      <div class="col-sm-6 offset-sm-3">
        <h1 class="text-center">
          {{ $t("usuario", 2) }}
        </h1>
      </div>
    </div>
    <UsuariosTable />
  </div>
</template>

<script>
import UsuariosTable from './components/UsuariosTable.vue';

export default {
  components: { UsuariosTable },
};
</script>
